// src/App.js
import {
  Brightness4,
  Brightness7,
  Menu as MenuIcon,
} from '@mui/icons-material';
import {
  AppBar,
  Box,
  Container,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery
} from '@mui/material';
import { motion } from 'framer-motion';
import React, { useEffect, useMemo, useState } from 'react';

// Component imports
import AIInsights from './components/Dashboard/AIInsights';
import AlertsSection from './components/Dashboard/AlertsSection';
import DistributionCharts from './components/Dashboard/DistributionCharts';
import Exports from './components/Dashboard/Exports';
import SummaryCards from './components/Dashboard/SummaryCards';


// import { Brightness4, Brightness7 } from '@mui/icons-material';
import { getTheme } from './theme';
import Footer from "./components/common/Footer"; // Import the Footer

const App = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [darkMode, setDarkMode] = useState(false);

  const [mode, setMode] = useState('dark'); // Default to dark mode
  const theme = useMemo(() => getTheme(mode), [mode]);

  // const theme = useMuiTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/dashboard_sample_data_template.json');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const json = await response.json();
        setData(json);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        {/* Loading state component will be added later */}
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        {/* Error state component will be added later */}
      </Box>
    );
  }

  // <ThemeProvider theme={theme}>
  //   <CssBaseline />
  //   <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>

      
      return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
          <AppBar position="sticky" elevation={0} color="inherit">
            <Toolbar>
              {isMobile && (
                <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
              )}
              <Box display="flex" alignItems="center" sx={{ flexGrow: 1 }}>
                <img
                  src="/images/one.png"
                  alt="ONE (4iG) logo"
                  style={{ height: 40, marginRight: theme.spacing(2) }}
                />
                <Typography variant="h6" component="div">
                  ONE AI Billing Demo Dashboard
                </Typography>
              </Box>
              {/* Right-aligned Branding */}
              <Typography variant="body2" sx={{ fontSize: "14px", color: "#1E88E5", opacity: 0.9 }}>
                Powered By - SkyVera ONE BSS Magic
              </Typography>
              <IconButton onClick={() => setMode(mode === 'light' ? 'dark' : 'light')}>
                {mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
              </IconButton>
            </Toolbar>
          </AppBar>

          <Container 
            maxWidth="lg"
            sx={{ 
              maxWidth: { 
                lg: '1200px !important'  // Custom max width
              },
              paddingBottom: "64px" // Ensures footer doesn't overlap
            }}
            className="pb-16 px-4 mt-4"
          >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <Typography variant="h" component="h1" gutterBottom>
                  Dashboard
                </Typography>
                
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <SummaryCards data={data.dashboardData} />
                  </Grid>
                  
                  <Grid item xs={12}>
                    <AlertsSection alerts={data.dashboardData.alerts} />
                  </Grid>
                  
                  <Grid item xs={12}>
                    <AIInsights insights={data.aiInsights} />
                  </Grid>
                  
                  <Grid item xs={12}>
                    <DistributionCharts 
                      serviceData={data.dashboardData.serviceDashboard}
                      geographicData={data.dashboardData.geographicData}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Exports data={data.exports} />
                  </Grid>

                </Grid>
              </motion.div>
          </Container>
          <Footer />
        </Box>
        
      );
      


  

};

export default App;











// import React, { useState, useEffect } from 'react';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   PieChart, Pie, Cell, Legend, Line, LineChart, Area, AreaChart,
//   ComposedChart, Scatter
// } from 'recharts';
// import { motion, AnimatePresence } from 'framer-motion';
// import { useTheme } from 'next-themes';
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   CardTitle,
//   CardDescription,
// } from "./components/ui/card";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "./components/ui/table";
// import { Badge } from "./components/ui/badge";
// import { Button } from "./components/ui/button";
// import { Skeleton } from "./components/ui/skeleton";
// import { Alert, AlertDescription, AlertTitle } from "./components/ui/alert";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";
// import {
//   Sheet,
//   SheetContent,
//   SheetDescription,
//   SheetHeader,
//   SheetTitle,
//   SheetTrigger,
// } from "./components/ui/sheet";
// import {
//   Tooltip as TooltipUI,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from "./components/ui/tooltip";
// import {
//   AlertCircle,
//   AlertTriangle,
//   Info,
//   ArrowRight,
//   ArrowUp,
//   ArrowDown,
//   BarChart2,
//   MapPin,
//   Users,
//   DollarSign,
//   Bell,
//   FileText,
//   UserCircle,
//   TrendingUp,
//   TrendingDown,
//   Percent,
//   ArrowUpRight,
//   ArrowDownRight,
//   Menu,
//   ChevronRight,
//   Plus,
//   Search,
//   HelpCircle,
// } from 'lucide-react';

// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from "./components/ui/dialog";
// import { Input } from "./components/ui/input";
// // import { ThemeProvider } from 'next-themes';
// // Animation variants
// const fadeIn = {
//   initial: { opacity: 0 },
//   animate: { opacity: 1 },
//   exit: { opacity: 0 }
// };

// const slideUp = {
//   initial: { y: 20, opacity: 0 },
//   animate: { y: 0, opacity: 1 },
//   transition: { duration: 0.3 }
// };

// // Color schemes for charts
// const chartColors = {
//   light: {
//     primary: '#652991',
//     secondary: '#f6b312',
//     success: '#10B981',
//     warning: '#F59E0B',
//     danger: '#EF4444',
//     text: '#1f2937',
//     grid: '#e5e7eb',
//     background: '#ffffff',
//   },
//   dark: {
//     primary: '#9333ea',
//     secondary: '#fbbf24',
//     success: '#34D399',
//     warning: '#FBBF24',
//     danger: '#F87171',
//     text: '#f3f4f6',
//     grid: '#374151',
//     background: '#1f2937',
//   }
// };

// // Donut chart colors with patterns for accessibility
// const DONUT_COLORS = ['#652991', '#f6b312', '#10B981', '#F59E0B', '#EF4444'];

// // Utility function for percentage calculation
// const calculatePercentage = (value, total) => {
//   return ((value / total) * 100).toFixed(1);
// };

// // Sparkline component
// const Sparkline = ({ data, color = '#652991', height = 30 }) => (
//   <ResponsiveContainer width="100%" height={height}>
//     <AreaChart data={data} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
//       <Area
//         type="monotone"
//         dataKey="value"
//         stroke={color}
//         fill={color}
//         fillOpacity={0.2}
//       />
//     </AreaChart>
//   </ResponsiveContainer>
// );

// // Custom tooltip component for cards
// const CustomTooltip = ({ content, children }) => (
//   <TooltipProvider>
//     <TooltipUI>
//       <TooltipTrigger asChild>
//         {children}
//       </TooltipTrigger>
//       <TooltipContent>
//         <p>{content}</p>
//       </TooltipContent>
//     </TooltipUI>
//   </TooltipProvider>
// );

// // Loading skeleton component with animation
// const LoadingSkeleton = () => (
//   <motion.div
//     variants={fadeIn}
//     initial="initial"
//     animate="animate"
//     className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6"
//   >
//     {[1, 2, 3, 4, 5].map((i) => (
//       <Card key={i}>
//         <CardHeader>
//           <Skeleton className="h-4 w-[250px]" />
//         </CardHeader>
//         <CardContent>
//           <Skeleton className="h-8 w-[200px]" />
//           <Skeleton className="h-4 w-[150px] mt-2" />
//         </CardContent>
//       </Card>
//     ))}
//   </motion.div>
// );

// // Trend indicator component
// const TrendIndicator = ({ value, previousValue }) => {
//   const percentageChange = ((value - previousValue) / previousValue * 100).toFixed(1);
//   const isPositive = value > previousValue;

//   return (
//     <div className={`flex items-center gap-1 text-sm ${isPositive ? 'text-success' : 'text-danger'}`}>
//       {isPositive ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
//       <span>{Math.abs(percentageChange)}%</span>
//     </div>
//   );
// };

// const App = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedAlert, setSelectedAlert] = useState(null);
//   const [selectedInsight, setSelectedInsight] = useState(null);
//   const [expandedReports, setExpandedReports] = useState({});
//   const [expandedCustomers, setExpandedCustomers] = useState({});
//   const [activeTab, setActiveTab] = useState('overview');
//   const { theme, setTheme } = useTheme();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch('/dashboard_sample_data_template.json');
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         const json = await response.json();
//         setData(json);
//       } catch (err) {
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-background p-8">
//         <LoadingSkeleton />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-background p-8">
//         <Alert variant="destructive">
//           <AlertCircle className="h-4 w-4" />
//           <AlertTitle>Error</AlertTitle>
//           <AlertDescription>Failed to load dashboard data: {error}</AlertDescription>
//         </Alert>
//       </div>
//     );
//   }

//   if (!data || !data.dashboardData) {
//     return (
//       <div className="min-h-screen bg-background p-8">
//         <Alert>
//           <Info className="h-4 w-4" />
//           <AlertTitle>No Data</AlertTitle>
//           <AlertDescription>No dashboard data available.</AlertDescription>
//         </Alert>
//       </div>
//     );
//   }

//   const { dashboardData, exports: exportData, aiInsights } = data;

//   // Calculate total customers affected percentage
//   const affectedPercentage = calculatePercentage(
//     dashboardData.summary.affected_customers,
//     dashboardData.summary.total_customers
//   );



//   const toggleReport = (idx) => {
//     setExpandedReports((prev) => ({
//       ...prev,
//       [idx]: !prev[idx],
//     }));
//   };

//   const toggleCustomerList = (idx) => {
//     setExpandedCustomers((prev) => ({
//       ...prev,
//       [idx]: !prev[idx],
//     }));
//   };

//   return (
//     <div className="min-h-screen bg-background transition-colors duration-200">
//       {/* Header with Navigation */}
//       <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
//         <div className="container flex h-16 items-center justify-between">
//           <div className="flex items-center gap-4">
//             <Button variant="ghost" size="icon" className="md:hidden">
//               <Menu className="h-5 w-5" />
//             </Button>
//             <img
//               src="https://upload.wikimedia.org/wikipedia/en/f/f7/One_%284iG%29_logo.svg"
//               alt="ONE (4iG) logo"
//               className="h-8"
//             />
//             <h1 className="text-xl font-bold hidden md:block">ONE Analytics</h1>
//           </div>
//           <div className="flex items-center gap-4">
//             <Tabs value={activeTab} onValueChange={setActiveTab} className="hidden md:flex">
//               <TabsList>
//                 <TabsTrigger value="overview">Overview</TabsTrigger>
//                 <TabsTrigger value="alerts">Alerts</TabsTrigger>
//                 <TabsTrigger value="insights">AI Insights</TabsTrigger>
//                 <TabsTrigger value="exports">Exports</TabsTrigger>
//               </TabsList>
//             </Tabs>
//             <Button
//               variant="ghost"
//               size="icon"
//               onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
//             >
//               {theme === 'dark' ? '🌞' : '🌙'}
//             </Button>
//           </div>
//         </div>
//       </header>

//       {/* Main Content */}
//       <main className="container py-8">
//         <motion.section
//           initial="initial"
//           animate="animate"
//           variants={fadeIn}
//           className="space-y-8"
//         >
//           {/* Dashboard Header with Breadcrumbs */}
//           <div className="flex items-center justify-between">
//             <div className="space-y-1">
//               <div className="flex items-center gap-1 text-sm text-muted-foreground">
//                 <span>Dashboard</span>
//                 <ChevronRight className="h-4 w-4" />
//                 <span>{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</span>
//               </div>
//               <h2 className="text-3xl font-bold tracking-tight">Dashboard Overview</h2>
//             </div>
//             <div className="flex items-center gap-4">
//               <Badge variant="outline" className="text-sm">
//                 Last updated: {new Date().toLocaleString()}
//               </Badge>
//             </div>
//           </div>

//           {/* Enhanced Summary Cards */}
//           <motion.div
//             variants={slideUp}
//             className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6"
//           >
//             {/* Total Customers Card */}
//             <Card>
//               <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//                 <CardTitle className="text-sm font-medium">Total Customers</CardTitle>
//                 <Users className="h-4 w-4 text-muted-foreground" />
//               </CardHeader>
//               <CardContent>
//                 <div className="text-2xl font-bold">
//                   {dashboardData.summary.total_customers.toLocaleString()}
//                 </div>
//                 <div className="flex items-center justify-between mt-2">
//                   <p className="text-xs text-muted-foreground">Base customer count</p>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Affected Customers Card */}
//             <Card>
//               <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//                 <CardTitle className="text-sm font-medium">Affected Customers</CardTitle>
//                 <AlertCircle className="h-4 w-4 text-muted-foreground" />
//               </CardHeader>
//               <CardContent>
//                 <div className="text-2xl font-bold">
//                   {dashboardData.summary.affected_customers.toLocaleString()}
//                 </div>
//                 <div className="flex items-center justify-between mt-2">
//                   <p className="text-xs text-muted-foreground">Impact rate</p>
//                   <Badge variant="secondary">{affectedPercentage}%</Badge>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Total Transactions Card */}
//             <Card>
//               <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//                 <CardTitle className="text-sm font-medium">Total Transactions</CardTitle>
//                 <BarChart2 className="h-4 w-4 text-muted-foreground" />
//               </CardHeader>
//               <CardContent>
//                 <div className="text-2xl font-bold">{dashboardData.summary.total_transactions}</div>
//                 <div className="flex items-center justify-between mt-2">
//                   <p className="text-xs text-muted-foreground">Processed volume</p>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Total Anomalies Card */}
//             <Card>
//               <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//                 <CardTitle className="text-sm font-medium">Total Anomalies</CardTitle>
//                 <AlertTriangle className="h-4 w-4 text-warning" />
//               </CardHeader>
//               <CardContent>
//                 <div className="text-2xl font-bold">{dashboardData.summary.total_anomalies}</div>
//                 <div className="flex items-center justify-between mt-2">
//                   <p className="text-xs text-muted-foreground">Detected issues</p>
//                   <div className="h-8">
//                     <Sparkline
//                       data={[
//                         { value: 300 },
//                         { value: 320 },
//                         { value: 336 }
//                       ]}
//                       color={theme === 'dark' ? chartColors.dark.warning : chartColors.light.warning}
//                     />
//                   </div>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Financial Impact Card */}
//             <Card>
//               <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//                 <CardTitle className="text-sm font-medium">Financial Impact</CardTitle>
//                 <DollarSign className="h-4 w-4 text-danger" />
//               </CardHeader>
//               <CardContent>
//                 <div className="text-2xl font-bold">{dashboardData.summary.financial_impact}</div>
//                 <div className="flex items-center justify-between mt-2">
//                   <p className="text-xs text-muted-foreground">Total value at risk</p>
//                   <div className="h-8">
//                     <Sparkline
//                       data={[
//                         { value: 25000 },
//                         { value: 27000 },
//                         { value: 28467 }
//                       ]}
//                       color={theme === 'dark' ? chartColors.dark.danger : chartColors.light.danger}
//                     />
//                   </div>
//                 </div>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </motion.section>
//         {/* AI Insights Section */}
//         <motion.section
//           variants={fadeIn}
//           className="mt-12 space-y-8"
//         >
//           <div className="flex items-center justify-between">
//             <h2 className="text-2xl font-bold tracking-tight">AI Insights</h2>
//             <Button variant="outline">Export Insights</Button>
//           </div>

//           {/* Priority Recommendations */}
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//             {aiInsights.recommendations.map((rec, i) => (
//               <motion.div
//                 key={i}
//                 variants={slideUp}
//                 className="relative"
//               >
//                 <Card className="h-full hover:shadow-lg transition-shadow">
//                   <CardHeader>
//                     <div className="flex justify-between items-start">
//                       <CardTitle className="text-base pr-4">{rec.title}</CardTitle>
//                       <Badge
//                         variant={rec.priority === 'HIGH' ? 'destructive' : 'secondary'}
//                         className="uppercase"
//                       >
//                         {rec.priority}
//                       </Badge>
//                     </div>
//                   </CardHeader>
//                   <CardContent className="space-y-4">
//                     {/* Brief Description with Tooltip */}
//                     <CustomTooltip content={rec.description}>
//                       <p className="text-sm text-muted-foreground line-clamp-2">
//                         {rec.description}
//                       </p>
//                     </CustomTooltip>

//                     {/* Impact Value */}
//                     <div className="flex items-center justify-between">
//                       <span className="text-sm font-medium">Impact</span>
//                       <span className="text-sm text-primary">{rec.impact}</span>
//                     </div>

//                     {/* Key Findings Preview */}
//                     {rec.key_findings && (
//                       <div className="space-y-1">
//                         <span className="text-sm font-medium">Key Findings:</span>
//                         <ul className="text-sm text-muted-foreground space-y-1">
//                           {rec.key_findings.slice(0, 2).map((finding, idx) => (
//                             <li key={idx} className="flex items-center gap-2">
//                               <span className="h-1.5 w-1.5 rounded-full bg-primary" />
//                               {finding}
//                             </li>
//                           ))}
//                           {rec.key_findings.length > 2 && (
//                             <li className="text-primary text-xs cursor-pointer"
//                               onClick={() => setSelectedInsight(rec)}>
//                               +{rec.key_findings.length - 2} more findings...
//                             </li>
//                           )}
//                         </ul>
//                       </div>
//                     )}

//                     <Button
//                       variant="outline"
//                       size="sm"
//                       className="w-full"
//                       onClick={() => setSelectedInsight(rec)}
//                     >
//                       View Details
//                       <ArrowRight className="ml-2 h-4 w-4" />
//                     </Button>
//                   </CardContent>
//                 </Card>
//               </motion.div>
//             ))}
//           </div>

//           {/* Emerging Patterns with Donut Chart */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
//             <Card className="h-full">
//               <CardHeader>
//                 <CardTitle>Emerging Patterns</CardTitle>
//               </CardHeader>
//               <CardContent>
//                 <div className="h-[300px]">
//                   <ResponsiveContainer width="100%" height="100%">
//                     <PieChart>
//                       <Pie
//                         data={aiInsights.emerging_patterns}
//                         dataKey="confidence"
//                         nameKey="pattern"
//                         cx="50%"
//                         cy="50%"
//                         innerRadius={60}
//                         outerRadius={80}
//                         paddingAngle={5}
//                         label={({ name, value }) => `${name} (${(value * 100).toFixed(0)}%)`}
//                       >
//                         {aiInsights.emerging_patterns.map((entry, index) => (
//                           <Cell key={`cell-${index}`} fill={DONUT_COLORS[index % DONUT_COLORS.length]} />
//                         ))}
//                       </Pie>
//                       <Tooltip
//                         content={({ payload }) => {
//                           if (payload && payload[0]) {
//                             const pattern = payload[0].payload;
//                             return (
//                               <div className="bg-background p-3 rounded-lg shadow-lg border">
//                                 <p className="font-medium">{pattern.pattern}</p>
//                                 <p className="text-sm text-muted-foreground">{pattern.description}</p>
//                                 {pattern.growth_rate && (
//                                   <p className="text-sm text-danger mt-1">{pattern.growth_rate}</p>
//                                 )}
//                               </div>
//                             );
//                           }
//                           return null;
//                         }}
//                       />
//                       <Legend />
//                     </PieChart>
//                   </ResponsiveContainer>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Impact Forecasts */}
//             <Card className="h-full">
//               <CardHeader>
//                 <CardTitle>Impact Forecasts</CardTitle>
//               </CardHeader>
//               <CardContent className="space-y-6">
//                 {Object.entries(aiInsights.impact_forecasts).map(([category, data], idx) => (
//                   <div key={idx} className="space-y-2">
//                     <h4 className="font-medium capitalize">{category.replace('_', ' ')}</h4>
//                     <div className="grid grid-cols-2 gap-4">
//                       {Object.entries(data).map(([key, value], i) => (
//                         <div key={i} className="space-y-1">
//                           <p className="text-sm text-muted-foreground capitalize">
//                             {key.replace('_', ' ')}
//                           </p>
//                           <p className="font-medium">{value}</p>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </CardContent>
//             </Card>
//           </div>

//           {/* Action Priorities */}
//           <div className="mt-8">
//             <Card>
//               <CardHeader>
//                 <CardTitle>Action Priorities</CardTitle>
//               </CardHeader>
//               <CardContent>
//                 <div className="space-y-4">
//                   {aiInsights.action_priorities.map((action, idx) => (
//                     <div key={idx} className="flex items-center justify-between p-4 border rounded-lg">
//                       <div className="space-y-1">
//                         <p className="font-medium">{action.initiative}</p>
//                         <p className="text-sm text-muted-foreground">Timeline: {action.timeline}</p>
//                       </div>
//                       <div className="text-right">
//                         <p className="font-medium text-primary">{action.impact_potential}</p>
//                         <p className="text-sm text-muted-foreground">
//                           {action.resources_required[0].effort}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </CardContent>
//             </Card>
//           </div>

//           {/* Insight Detail Modal */}
//           <AnimatePresence>
//             {selectedInsight && (
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50"
//                 onClick={() => setSelectedInsight(null)}
//               >
//                 <motion.div
//                   initial={{ scale: 0.95 }}
//                   animate={{ scale: 1 }}
//                   exit={{ scale: 0.95 }}
//                   onClick={(e) => e.stopPropagation()}
//                   className="container max-w-2xl mx-auto mt-20 p-6 bg-card rounded-lg shadow-lg"
//                 >
//                   <div className="space-y-4">
//                     <div className="flex justify-between items-start">
//                       <h3 className="text-xl font-bold">{selectedInsight.title}</h3>
//                       <Badge variant={selectedInsight.priority === 'HIGH' ? 'destructive' : 'secondary'}>
//                         {selectedInsight.priority}
//                       </Badge>
//                     </div>

//                     <p className="text-muted-foreground">{selectedInsight.description}</p>

//                     {selectedInsight.key_findings && (
//                       <div className="space-y-2">
//                         <h4 className="font-medium">Key Findings</h4>
//                         <ul className="space-y-2">
//                           {selectedInsight.key_findings.map((finding, idx) => (
//                             <li key={idx} className="flex items-start gap-2">
//                               <span className="h-1.5 w-1.5 rounded-full bg-primary mt-2" />
//                               <span>{finding}</span>
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     )}

//                     {selectedInsight.data_signals && (
//                       <div className="space-y-2">
//                         <h4 className="font-medium">Data Signals</h4>
//                         <div className="grid grid-cols-2 gap-4">
//                           {Object.entries(selectedInsight.data_signals).map(([key, value], idx) => (
//                             <div key={idx} className="space-y-1">
//                               <p className="text-sm text-muted-foreground capitalize">
//                                 {key.replace(/_/g, ' ')}
//                               </p>
//                               <p>{value}</p>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     <div className="flex justify-end gap-2 mt-6">
//                       <Button variant="outline" onClick={() => setSelectedInsight(null)}>
//                         Close
//                       </Button>
//                     </div>
//                   </div>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </motion.section>
//         {/* Alerts Section */}
//         <motion.section
//           variants={fadeIn}
//           className="mt-12 space-y-8"
//         >
//           <div className="flex items-center justify-between">
//             <div className="space-y-1">
//               <h2 className="text-2xl font-bold tracking-tight">Alerts Overview</h2>
//               <p className="text-muted-foreground">
//                 {dashboardData.alerts.critical.length +
//                   dashboardData.alerts.medium.length +
//                   dashboardData.alerts.low.length} total alerts detected
//               </p>
//             </div>

//             {/* Alert Distribution Donut Chart */}
//             <Card className="w-72">
//               <CardContent className="p-4">
//                 <ResponsiveContainer width="100%" height={100}>
//                   <PieChart>
//                     <Pie
//                       data={[
//                         { name: 'Critical', value: dashboardData.alerts.critical.length, color: chartColors.light.danger },
//                         { name: 'Medium', value: dashboardData.alerts.medium.length, color: chartColors.light.warning },
//                         { name: 'Low', value: dashboardData.alerts.low.length, color: chartColors.light.primary }
//                       ]}
//                       dataKey="value"
//                       nameKey="name"
//                       cx="50%"
//                       cy="50%"
//                       innerRadius={25}
//                       outerRadius={40}
//                       paddingAngle={2}
//                     >
//                       {(entry, index) => (
//                         <Cell key={`cell-${index}`} fill={entry.color} />
//                       )}
//                     </Pie>
//                     <Tooltip
//                       content={({ payload }) => {
//                         if (payload && payload[0]) {
//                           return (
//                             <div className="bg-background p-2 rounded-lg shadow border">
//                               <p className="font-medium">{payload[0].name}</p>
//                               <p className="text-sm">{payload[0].value} alerts</p>
//                             </div>
//                           );
//                         }
//                         return null;
//                       }}
//                     />
//                     <Legend />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </CardContent>
//             </Card>
//           </div>

//           {/* Critical Alerts */}
//           {dashboardData.alerts.critical.length > 0 && (
//             <div className="space-y-4">
//               <div className="flex items-center gap-2">
//                 <AlertCircle className="h-5 w-5 text-danger" />
//                 <h3 className="text-lg font-semibold text-danger">Critical Alerts</h3>
//               </div>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                 {dashboardData.alerts.critical.map((alert, i) => (
//                   <motion.div
//                     key={i}
//                     variants={slideUp}
//                     className="relative"
//                   >
//                     <Card
//                       className="hover:shadow-lg transition-shadow cursor-pointer border-l-4 border-l-danger"
//                       onClick={() => setSelectedAlert(alert)}
//                     >
//                       <CardHeader className="pb-2">
//                         <div className="flex justify-between items-start">
//                           <CardTitle className="text-base">{alert.type}</CardTitle>
//                           <Badge variant="destructive">{alert.severity}</Badge>
//                         </div>
//                       </CardHeader>
//                       <CardContent className="space-y-3">
//                         <CustomTooltip content={alert.description}>
//                           <p className="text-sm text-muted-foreground line-clamp-2">
//                             {alert.description}
//                           </p>
//                         </CustomTooltip>

//                         <div className="grid grid-cols-2 gap-4">
//                           <div className="space-y-1">
//                             <p className="text-sm text-muted-foreground">Count</p>
//                             <p className="font-medium">{alert.count}</p>
//                           </div>
//                           <div className="space-y-1">
//                             <p className="text-sm text-muted-foreground">Impact</p>
//                             <p className="font-medium">{alert.impact}</p>
//                           </div>
//                         </div>

//                         {alert.trend && (
//                           <div className="pt-2">
//                             <div className="flex items-center justify-between mb-1">
//                               <span className="text-sm text-muted-foreground">Trend</span>
//                               <TrendIndicator
//                                 value={alert.trend[alert.trend.length - 1]}
//                                 previousValue={alert.trend[0]}
//                               />
//                             </div>
//                             <div className="h-10">
//                               <Sparkline
//                                 data={alert.trend.map(value => ({ value }))}
//                                 color={theme === 'dark' ? chartColors.dark.danger : chartColors.light.danger}
//                               />
//                             </div>
//                           </div>
//                         )}

//                         {alert.affected_services && (
//                           <div className="flex flex-wrap gap-1">
//                             {alert.affected_services.map((service, idx) => (
//                               <Badge key={idx} variant="outline" className="text-xs">
//                                 {service}
//                               </Badge>
//                             ))}
//                           </div>
//                         )}
//                       </CardContent>
//                     </Card>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Medium Alerts - Similar structure to Critical but with warning colors */}
//           {dashboardData.alerts.medium.length > 0 && (
//             <div className="space-y-4 mt-8">
//               <div className="flex items-center gap-2">
//                 <AlertTriangle className="h-5 w-5 text-warning" />
//                 <h3 className="text-lg font-semibold text-warning">Medium Alerts</h3>
//               </div>
//               {/* Similar card structure as Critical Alerts but with warning theme */}
//             </div>
//           )}

//           {/* Low Alerts - Similar structure but with info colors */}
//           {dashboardData.alerts.low.length > 0 && (
//             <div className="space-y-4 mt-8">
//               <div className="flex items-center gap-2">
//                 <Info className="h-5 w-5 text-primary" />
//                 <h3 className="text-lg font-semibold text-primary">Low Priority Alerts</h3>
//               </div>
//               {/* Similar card structure as Critical Alerts but with primary theme */}
//             </div>
//           )}

//           {/* Enhanced Alert Detail Modal */}
//           <AnimatePresence>
//             {selectedAlert && (
//               <motion.div
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50"
//                 onClick={() => setSelectedAlert(null)}
//               >
//                 <motion.div
//                   initial={{ scale: 0.95 }}
//                   animate={{ scale: 1 }}
//                   exit={{ scale: 0.95 }}
//                   onClick={(e) => e.stopPropagation()}
//                   className="container max-w-2xl mx-auto mt-20 p-6 bg-card rounded-lg shadow-lg"
//                 >
//                   <div className="space-y-6">
//                     <div className="flex justify-between items-start">
//                       <div>
//                         <h3 className="text-xl font-bold">{selectedAlert.type}</h3>
//                         <p className="text-sm text-muted-foreground">Alert Details</p>
//                       </div>
//                       <Badge
//                         variant={
//                           selectedAlert.severity === 'HIGH' ? 'destructive' :
//                             selectedAlert.severity === 'MEDIUM' ? 'warning' : 'default'
//                         }
//                       >
//                         {selectedAlert.severity}
//                       </Badge>
//                     </div>

//                     <div className="space-y-4">
//                       <p className="text-muted-foreground">{selectedAlert.description}</p>

//                       <div className="grid grid-cols-2 gap-6">
//                         <div>
//                           <p className="text-sm text-muted-foreground mb-1">Count</p>
//                           <p className="text-xl font-bold">{selectedAlert.count}</p>
//                         </div>
//                         <div>
//                           <p className="text-sm text-muted-foreground mb-1">Impact</p>
//                           <p className="text-xl font-bold">{selectedAlert.impact}</p>
//                         </div>
//                       </div>

//                       {selectedAlert.trend && (
//                         <div>
//                           <div className="flex items-center justify-between mb-2">
//                             <p className="font-medium">Trend Analysis</p>
//                             <TrendIndicator
//                               value={selectedAlert.trend[selectedAlert.trend.length - 1]}
//                               previousValue={selectedAlert.trend[0]}
//                             />
//                           </div>
//                           <div className="h-40">
//                             <ResponsiveContainer width="100%" height="100%">
//                               <LineChart data={selectedAlert.trend.map((value, index) => ({ value, index }))}>
//                                 <CartesianGrid strokeDasharray="3 3" />
//                                 <XAxis dataKey="index" />
//                                 <YAxis />
//                                 <Tooltip />
//                                 <Line
//                                   type="monotone"
//                                   dataKey="value"
//                                   stroke={theme === 'dark' ? chartColors.dark.primary : chartColors.light.primary}
//                                   strokeWidth={2}
//                                 />
//                               </LineChart>
//                             </ResponsiveContainer>
//                           </div>
//                         </div>
//                       )}

//                       {selectedAlert.affected_services && (
//                         <div>
//                           <p className="font-medium mb-2">Affected Services</p>
//                           <div className="flex flex-wrap gap-2">
//                             {selectedAlert.affected_services.map((service, idx) => (
//                               <Badge key={idx} variant="outline">
//                                 {service}
//                               </Badge>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     <div className="flex justify-end gap-2 pt-4 border-t">
//                       <Button variant="outline" onClick={() => setSelectedAlert(null)}>
//                         Close
//                       </Button>
//                       <Button>Take Action</Button>
//                     </div>
//                   </div>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </motion.section>
//         {/* Distribution Charts Section */}
//         <motion.section
//           variants={fadeIn}
//           className="mt-12 space-y-8"
//         >
//           <div className="flex items-center justify-between">
//             <h2 className="text-2xl font-bold tracking-tight">Anomaly Distribution</h2>
//             <div className="flex gap-2">
//               <Button variant="outline" size="sm">
//                 <FileText className="h-4 w-4 mr-2" />
//                 Export Data
//               </Button>
//               <Button variant="outline" size="sm">
//                 <MapPin className="h-4 w-4 mr-2" />
//                 View Full Map
//               </Button>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
//             {/* Service Distribution */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>Service Distribution</CardTitle>
//                 <CardDescription>
//                   Anomaly distribution across different services
//                 </CardDescription>
//               </CardHeader>
//               <CardContent>
//                 <div className="h-[400px] grid grid-cols-2">
//                   {/* Donut Chart */}
//                   <div className="h-full">
//                     <ResponsiveContainer width="100%" height="100%">
//                       <PieChart>
//                         <Pie
//                           data={Object.entries(dashboardData.serviceDashboard).map(([name, data]) => ({
//                             name,
//                             value: data.anomalies,
//                             impact: data.impact
//                           }))}
//                           cx="50%"
//                           cy="50%"
//                           innerRadius={60}
//                           outerRadius={80}
//                           paddingAngle={5}
//                           dataKey="value"
//                         >
//                           {Object.entries(dashboardData.serviceDashboard).map((entry, index) => (
//                             <Cell
//                               key={`cell-${index}`}
//                               fill={DONUT_COLORS[index % DONUT_COLORS.length]}
//                             />
//                           ))}
//                         </Pie>
//                         <Tooltip
//                           content={({ payload }) => {
//                             if (payload && payload[0]) {
//                               const data = payload[0].payload;
//                               return (
//                                 <div className="bg-background p-3 rounded-lg shadow-lg border">
//                                   <p className="font-medium">{data.name}</p>
//                                   <p className="text-sm">Anomalies: {data.value}</p>
//                                   <p className="text-sm">Impact: {data.impact}</p>
//                                 </div>
//                               );
//                             }
//                             return null;
//                           }}
//                         />
//                         <Legend />
//                       </PieChart>
//                     </ResponsiveContainer>
//                   </div>

//                   {/* Service Details */}
//                   <div className="space-y-4 p-4">
//                     {Object.entries(dashboardData.serviceDashboard).map(([service, data], index) => (
//                       <div key={service} className="space-y-2">
//                         <div className="flex items-center justify-between">
//                           <div className="flex items-center gap-2">
//                             <div
//                               className="h-3 w-3 rounded-full"
//                               style={{ backgroundColor: DONUT_COLORS[index % DONUT_COLORS.length] }}
//                             />
//                             <span className="font-medium">{service}</span>
//                           </div>
//                           <Badge variant="outline">{data.anomalies}</Badge>
//                         </div>
//                         {data.distribution && (
//                           <div className="h-8">
//                             <Sparkline
//                               data={data.distribution.map(value => ({ value }))}
//                               color={DONUT_COLORS[index % DONUT_COLORS.length]}
//                             />
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </CardContent>
//             </Card>

//             {/* Geographic Distribution */}
//             <Card>
//               <CardHeader>
//                 <CardTitle>Geographic Distribution</CardTitle>
//                 <CardDescription>
//                   Regional anomaly concentration
//                 </CardDescription>
//               </CardHeader>
//               <CardContent>
//                 <div className="h-[400px] grid grid-cols-2">
//                   {/* Donut Chart */}
//                   <div className="h-full">
//                     <ResponsiveContainer width="100%" height="100%">
//                       <PieChart>
//                         <Pie
//                           data={Object.entries(dashboardData.geographicData)
//                             .sort((a, b) => b[1].anomalies - a[1].anomalies)
//                             .slice(0, 5)
//                             .map(([region, data]) => ({
//                               name: region,
//                               value: data.anomalies,
//                               impact: data.impact,
//                               services: data.services
//                             }))}
//                           cx="50%"
//                           cy="50%"
//                           innerRadius={60}
//                           outerRadius={80}
//                           paddingAngle={5}
//                           dataKey="value"
//                         >
//                           {Object.entries(dashboardData.geographicData)
//                             .sort((a, b) => b[1].anomalies - a[1].anomalies)
//                             .slice(0, 5)
//                             .map((entry, index) => (
//                               <Cell
//                                 key={`cell-${index}`}
//                                 fill={DONUT_COLORS[index % DONUT_COLORS.length]}
//                               />
//                             ))}
//                         </Pie>
//                         <Tooltip
//                           content={({ payload }) => {
//                             if (payload && payload[0]) {
//                               const data = payload[0].payload;
//                               return (
//                                 <div className="bg-background p-3 rounded-lg shadow-lg border">
//                                   <p className="font-medium">{data.name}</p>
//                                   <p className="text-sm">Anomalies: {data.value}</p>
//                                   <p className="text-sm">Impact: {data.impact}</p>
//                                   <div className="flex flex-wrap gap-1 mt-1">
//                                     {data.services.map((service, idx) => (
//                                       <Badge key={idx} variant="outline" className="text-xs">
//                                         {service}
//                                       </Badge>
//                                     ))}
//                                   </div>
//                                 </div>
//                               );
//                             }
//                             return null;
//                           }}
//                         />
//                         <Legend />
//                       </PieChart>
//                     </ResponsiveContainer>
//                   </div>

//                   {/* Region Details */}
//                   <div className="space-y-4 p-4">
//                     {Object.entries(dashboardData.geographicData)
//                       .sort((a, b) => b[1].anomalies - a[1].anomalies)
//                       .map(([region, data], index) => (
//                         <div key={region} className="space-y-2">
//                           <div className="flex items-center justify-between">
//                             <div className="flex items-center gap-2">
//                               <div
//                                 className="h-3 w-3 rounded-full"
//                                 style={{ backgroundColor: DONUT_COLORS[index % DONUT_COLORS.length] }}
//                               />
//                               <span className="font-medium">{region}</span>
//                             </div>
//                             <div className="flex items-center gap-2">
//                               <Badge variant="outline">{data.anomalies}</Badge>
//                               <Badge variant="secondary">{data.impact}</Badge>
//                             </div>
//                           </div>
//                           {data.trend && (
//                             <div className="h-8">
//                               <Sparkline
//                                 data={data.trend.map(value => ({ value }))}
//                                 color={DONUT_COLORS[index % DONUT_COLORS.length]}
//                               />
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                   </div>
//                 </div>

//                 {/* Additional Regional Stats */}
//                 <div className="mt-6 grid grid-cols-3 gap-4">
//                   <Card>
//                     <CardContent className="pt-6">
//                       <div className="text-center">
//                         <div className="text-2xl font-bold text-primary">
//                           {Object.keys(dashboardData.geographicData).length}
//                         </div>
//                         <p className="text-sm text-muted-foreground">
//                           Regions Affected
//                         </p>
//                       </div>
//                     </CardContent>
//                   </Card>
//                   <Card>
//                     <CardContent className="pt-6">
//                       <div className="text-center">
//                         <div className="text-2xl font-bold text-primary">
//                           {Object.values(dashboardData.geographicData)
//                             .reduce((acc, curr) => acc + curr.anomalies, 0)}
//                         </div>
//                         <p className="text-sm text-muted-foreground">
//                           Total Regional Anomalies
//                         </p>
//                       </div>
//                     </CardContent>
//                   </Card>
//                   <Card>
//                     <CardContent className="pt-6">
//                       <div className="text-center">
//                         <div className="text-2xl font-bold text-primary">
//                           {Object.values(dashboardData.geographicData)
//                             .reduce((acc, curr) =>
//                               acc + parseFloat(curr.impact.replace('€', '').replace(',', '')), 0)
//                             .toLocaleString('en-US', {
//                               style: 'currency',
//                               currency: 'EUR',
//                               minimumFractionDigits: 0,
//                               maximumFractionDigits: 0
//                             })}
//                         </div>
//                         <p className="text-sm text-muted-foreground">
//                           Total Regional Impact
//                         </p>
//                       </div>
//                     </CardContent>
//                   </Card>
//                 </div>
//               </CardContent>
//             </Card>
//           </div>
//         </motion.section>
//         {/* Exports Section */}
//         <motion.section
//           variants={fadeIn}
//           className="mt-12 space-y-8"
//         >
//           <div className="flex items-center justify-between">
//             <div>
//               <h2 className="text-2xl font-bold tracking-tight">Exports & Reports</h2>
//               <p className="text-muted-foreground">
//                 {exportData.reports.length} reports and {exportData.customerLists.length} customer lists available
//               </p>
//             </div>
//             <div className="flex gap-2">
//               <Button variant="outline" size="sm">
//                 <FileText className="h-4 w-4 mr-2" />
//                 Export All
//               </Button>
//               <Button variant="outline" size="sm">
//                 <UserCircle className="h-4 w-4 mr-2" />
//                 Export Customers
//               </Button>
//             </div>
//           </div>

//           {/* Reports Section */}
//           {exportData.reports?.length > 0 && (
//             <div className="space-y-6">
//               <div className="flex items-center justify-between">
//                 <h3 className="text-lg font-semibold">Reports</h3>
//                 <Tabs defaultValue="all" className="w-[400px]">
//                   <TabsList className="grid w-full grid-cols-3">
//                     <TabsTrigger value="all">All</TabsTrigger>
//                     <TabsTrigger value="risk">Risk Analysis</TabsTrigger>
//                     <TabsTrigger value="impact">Impact</TabsTrigger>
//                   </TabsList>
//                 </Tabs>
//               </div>

//               <div className="space-y-4">
//                 {exportData.reports.map((report, idx) => (
//                   <Card key={idx} className="overflow-hidden">
//                     <CardHeader className="bg-muted/50">
//                       <div className="flex items-center justify-between">
//                         <div className="space-y-1">
//                           <CardTitle>{report.title}</CardTitle>
//                           <CardDescription>
//                             Format: {report.type} • {report.data?.length || 0} entries
//                           </CardDescription>
//                         </div>
//                         <Button
//                           variant="ghost"
//                           size="sm"
//                           onClick={() => toggleReport(idx)}
//                         >
//                           {expandedReports[idx] ? (
//                             <motion.span
//                               initial={{ rotate: 180 }}
//                               animate={{ rotate: 0 }}
//                               className="flex items-center gap-2"
//                             >
//                               <ArrowUp className="h-4 w-4" /> Hide Details
//                             </motion.span>
//                           ) : (
//                             <motion.span
//                               initial={{ rotate: 0 }}
//                               animate={{ rotate: 0 }}
//                               className="flex items-center gap-2"
//                             >
//                               <ArrowDown className="h-4 w-4" /> Show Details
//                             </motion.span>
//                           )}
//                         </Button>
//                       </div>
//                     </CardHeader>
//                     <AnimatePresence>
//                       {expandedReports[idx] && (
//                         <motion.div
//                           initial={{ height: 0 }}
//                           animate={{ height: "auto" }}
//                           exit={{ height: 0 }}
//                           className="overflow-hidden"
//                         >
//                           <CardContent className="p-0">
//                             {report.data ? (
//                               <div className="border-t">
//                                 <Table>
//                                   <TableHeader>
//                                     <TableRow>
//                                       {Object.keys(report.data[0]).map((header) => (
//                                         <TableHead key={header} className="capitalize">
//                                           {header.replace(/_/g, ' ')}
//                                         </TableHead>
//                                       ))}
//                                     </TableRow>
//                                   </TableHeader>
//                                   <TableBody>
//                                     {report.data.map((row, rowIdx) => (
//                                       <TableRow key={rowIdx}>
//                                         {Object.entries(row).map(([key, value], cellIdx) => (
//                                           <TableCell key={cellIdx}>
//                                             {Array.isArray(value) ? (
//                                               <div className="flex flex-wrap gap-1">
//                                                 {value.map((item, i) => (
//                                                   <Badge key={i} variant="outline" className="text-xs">
//                                                     {item}
//                                                   </Badge>
//                                                 ))}
//                                               </div>
//                                             ) : (
//                                               value
//                                             )}
//                                           </TableCell>
//                                         ))}
//                                       </TableRow>
//                                     ))}
//                                   </TableBody>
//                                 </Table>
//                               </div>
//                             ) : (
//                               <div className="p-4 text-center text-muted-foreground">
//                                 No data available in this report.
//                               </div>
//                             )}
//                           </CardContent>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </Card>
//                 ))}
//               </div>
//             </div>
//           )}

//           {/* Customer Lists Section */}
//           {exportData.customerLists?.length > 0 && (
//             <div className="space-y-6 mt-8">
//               <div className="flex items-center justify-between">
//                 <h3 className="text-lg font-semibold">Customer Lists</h3>
//                 <div className="flex items-center gap-4">
//                   <Button variant="outline" size="sm">
//                     <Users className="h-4 w-4 mr-2" />
//                     Download All Lists
//                   </Button>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 {exportData.customerLists.map((list, idx) => (
//                   <Card key={idx} className="overflow-hidden">
//                     <CardHeader className="bg-muted/50">
//                       <div className="flex items-center justify-between">
//                         <div className="space-y-1">
//                           <CardTitle>{list.title}</CardTitle>
//                           <CardDescription>
//                             Format: {list.format} • {list.records?.length || 0} customers
//                           </CardDescription>
//                         </div>
//                         <Button
//                           variant="ghost"
//                           size="sm"
//                           onClick={() => toggleCustomerList(idx)}
//                         >
//                           {expandedCustomers[idx] ? (
//                             <motion.span
//                               initial={{ rotate: 180 }}
//                               animate={{ rotate: 0 }}
//                               className="flex items-center gap-2"
//                             >
//                               <ArrowUp className="h-4 w-4" /> Hide Records
//                             </motion.span>
//                           ) : (
//                             <motion.span
//                               initial={{ rotate: 0 }}
//                               animate={{ rotate: 0 }}
//                               className="flex items-center gap-2"
//                             >
//                               <ArrowDown className="h-4 w-4" /> Show Records
//                             </motion.span>
//                           )}
//                         </Button>
//                       </div>
//                     </CardHeader>
//                     <AnimatePresence>
//                       {expandedCustomers[idx] && (
//                         <motion.div
//                           initial={{ height: 0 }}
//                           animate={{ height: "auto" }}
//                           exit={{ height: 0 }}
//                           className="overflow-hidden"
//                         >
//                           <CardContent className="p-0">
//                             {list.records ? (
//                               <div className="border-t">
//                                 <Table>
//                                   <TableHeader>
//                                     <TableRow>
//                                       {Object.keys(list.records[0]).map((header) => (
//                                         <TableHead key={header} className="capitalize">
//                                           {header.replace(/_/g, ' ')}
//                                         </TableHead>
//                                       ))}
//                                     </TableRow>
//                                   </TableHeader>
//                                   <TableBody>
//                                     {list.records.map((record, recordIdx) => (
//                                       <TableRow key={recordIdx}>
//                                         {Object.entries(record).map(([key, value], cellIdx) => (
//                                           <TableCell key={cellIdx}>
//                                             {key === 'priority' ? (
//                                               <Badge
//                                                 variant={
//                                                   value === 'HIGH' ? 'destructive' :
//                                                     value === 'MEDIUM' ? 'warning' :
//                                                       'default'
//                                                 }
//                                               >
//                                                 {value}
//                                               </Badge>
//                                             ) : (
//                                               value
//                                             )}
//                                           </TableCell>
//                                         ))}
//                                       </TableRow>
//                                     ))}
//                                   </TableBody>
//                                 </Table>
//                               </div>
//                             ) : (
//                               <div className="p-4 text-center text-muted-foreground">
//                                 No records available in this list.
//                               </div>
//                             )}
//                           </CardContent>
//                         </motion.div>
//                       )}
//                     </AnimatePresence>
//                   </Card>
//                 ))}
//               </div>
//             </div>
//           )}
//         </motion.section>
//       </main>

//       {/* Quick Action Floating Button */}
//       <motion.div
//         className="fixed bottom-6 right-6"
//         initial={{ scale: 0 }}
//         animate={{ scale: 1 }}
//         transition={{ delay: 1 }}
//       >
//         <TooltipProvider>
//           <TooltipUI>
//             <TooltipTrigger asChild>
//               <Button
//                 size="lg"
//                 className="rounded-full h-12 w-12 shadow-lg"
//                 onClick={() => {
//                   // Handle quick action
//                 }}
//               >
//                 <Plus className="h-6 w-6" />
//               </Button>
//             </TooltipTrigger>
//             <TooltipContent>
//               <p>Quick Actions</p>
//             </TooltipContent>
//           </TooltipUI>
//         </TooltipProvider>
//       </motion.div>

//       {/* Search Dialog */}
//       <Dialog>
//         <DialogTrigger asChild>
//           <Button
//             variant="outline"
//             className="fixed top-4 left-1/2 transform -translate-x-1/2 w-72"
//           >
//             <Search className="h-4 w-4 mr-2" />
//             Search dashboard...
//           </Button>
//         </DialogTrigger>
//         <DialogContent>
//           <DialogHeader>
//             <DialogTitle>Search Dashboard</DialogTitle>
//             <DialogDescription>
//               Search through alerts, insights, and reports
//             </DialogDescription>
//           </DialogHeader>
//           <div className="space-y-4 py-4">
//             <div className="flex items-center space-x-4">
//               <Input placeholder="Type to search..." />
//             </div>
//             {/* Search results would go here */}
//           </div>
//         </DialogContent>
//       </Dialog>

//       {/* Help Button */}
//       <Button
//         variant="outline"
//         size="icon"
//         className="fixed bottom-6 left-6"
//         onClick={() => {
//           // Handle help action
//         }}
//       >
//         <HelpCircle className="h-4 w-4" />
//       </Button>
//     </div>
//   );
// };

// // Utility function for time formatting
// const formatTime = (date) => {
//   return new Intl.DateTimeFormat('en-US', {
//     hour: 'numeric',
//     minute: 'numeric',
//     hour12: true
//   }).format(new Date(date));
// };

// // Utility function for number formatting
// const formatNumber = (number) => {
//   return new Intl.NumberFormat('en-US', {
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 2
//   }).format(number);
// };

// // Utility function for currency formatting
// const formatCurrency = (amount, currency = 'EUR') => {
//   return new Intl.NumberFormat('en-US', {
//     style: 'currency',
//     currency: currency,
//     minimumFractionDigits: 0,
//     maximumFractionDigits: 2
//   }).format(amount);
// };

// // Utility function to get trend direction
// const getTrendDirection = (values) => {
//   if (values.length < 2) return 'neutral';
//   const firstValue = values[0];
//   const lastValue = values[values.length - 1];
//   if (lastValue > firstValue) return 'up';
//   if (lastValue < firstValue) return 'down';
//   return 'neutral';
// };

// // Utility function to get trend color
// const getTrendColor = (direction, theme) => {
//   const colors = theme === 'dark' ? chartColors.dark : chartColors.light;
//   switch (direction) {
//     case 'up':
//       return colors.success;
//     case 'down':
//       return colors.danger;
//     default:
//       return colors.primary;
//   }
// };

// // Utility function to calculate percentage change
// const calculatePercentageChange = (oldValue, newValue) => {
//   if (oldValue === 0) return 100;
//   return ((newValue - oldValue) / oldValue) * 100;
// };

// export default App;